import * as React from 'react';
import { Link } from 'react-router';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';

export interface Props {
  title: string;
  active: boolean;
  url: string;
}

function SidebarLink({ title, url, active }: Props) {
  return (
    <Wrapper active={active} to={url}>
      {title}
    </Wrapper>
  );
}

export const linkCss = css<any>`
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(22)};
  text-decoration: none;
  width: fit-content;
  color: ${({ theme, active }) =>
    active ? theme.colors.primary : theme.colors.textPrimary};
  margin-bottom: ${rem(24)};

  &:hover {
    text-decoration: underline;
  }

  ${({ theme }) => theme.mediab.l925`
     margin: 0;
     margin-right: ${rem(24)};
  `}
`;

const Wrapper = styled(Link)`
  ${linkCss}
`;

export { SidebarLink };
